import { APPLICATIONS_IDENTIFIER } from "constants/APPLICATIONS";
import { IUser } from "./auth.types";
import { IForm } from "./forms.types";

export type TJob = "cto" | "hr";
export type TKey =
  | "leaveDate"
  | "leaveDates"
  | "leaveType"
  | "leaveHour"
  | "leaveStartDate"
  | "leaveEndDate"
  | "missionLocation"
  | "missionDescription"
  | "requestedAmount"
  | "requestDescription"
  | "certificateContact"
  | "certificateDescription"
  | "attachedMedia";

export interface IRequestLog {
  reviewBy: string;
  reviewAt: string;
  isAccepted: boolean;
  _id: string;
}
export interface IRequestApproval {
  job: TJob;
  logs: IRequestLog[];
  isAccepted: boolean;
  _id: string;
}
export interface IRequestViewApproval {
  job: TJob;
  names: string[];
  reviewAction: { isAccepted: boolean; description: string } | null;
  instead: Omit<IRequestViewApproval, "instead">[];
  avatar?: string;
}
export interface IRequestApprovalUsers {
  _id: string;
  firstName: string;
  lastName: string;
  username: string;
  mobile: string;
  gender: number;
  job: TJob;
}
export enum IRequestStatus {
  inFlow = 1,
  done = 2,
  rejected = 3,
  canceled = 4,
}
export interface IRequestField {
  key: TKey;
  value: string;
  _id: string;
}
export interface IRequestFlow {
  _id: string;
  job: TJob;
  approvals: TJob[];
}
export interface IRequestForm extends IForm {
  flow: IRequestFlow[];
}
export interface IRequest {
  _id: string;
  createdAt: string;
  leaveDates?: string[];
  user: IUser;
  form: IRequestForm;
  status: IRequestStatus;
  fields: IRequestField[];
  approvals: IRequestApproval[];
  approvalsUsers: IRequestApprovalUsers[];
  pendingApprovalJobs: TJob[];
  viewApprovals: IRequestViewApproval[];
}
export interface IRequests {
  data: IRequest[];
  count: number;
}
export interface IRequestsQuery {
  page: number;
  limit: number;
  formIdentifier?: APPLICATIONS_IDENTIFIER | undefined;
  fromDate?: string;
  toDate?: string;
}
